import { render } from "./CmpSecciones.vue?vue&type=template&id=d97299aa&scoped=true"
import script from "./CmpSecciones.vue?vue&type=script&lang=js"
export * from "./CmpSecciones.vue?vue&type=script&lang=js"

import "./CmpSecciones.vue?vue&type=style&index=0&id=d97299aa&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d97299aa"]])

export default __exports__